export default __webpack_public_path__ + "static/media/me.fb972535.jpg";